export default __webpack_public_path__ + "media/images/cta_blocks/assign_guests-bdffce5b1729be181aa8e989ad18ee1d.jpg";